// API Configuration
// This will use environment variables to determine the API base URL

const getApiBaseUrl = (): string => {
  // First try to get from React environment variable
  if (process.env.APP_BASE_URL) {
    return process.env.APP_BASE_URL;
  }
  
  // Check if we're in development or production
  if (process.env.NODE_ENV === 'development') {
    // In development, default to localhost:3003
    return 'http://localhost:3003';
  }

  // In production, assume API is served from same domain but different port
  // This assumes the backend runs on port 3003 in production too
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  return `${protocol}//${hostname}`;
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to construct API URLs
export const apiUrl = (path: string): string => {
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${cleanPath}`;
};

const apiConfig = {
  BASE_URL: API_BASE_URL,
  url: apiUrl
};

export default apiConfig;